/* import __COLOCATED_TEMPLATE__ from './tantcap-pos.hbs'; */
import Component from '@glimmer/component';
import type { CapacitorItem } from './bypass-capacitors-container';

interface TantalumCapacitorToPositiveArgs {
  circuitValues: CapacitorItem;
  index: number;
}

export default class TantalumCapacitorToPositive extends Component<TantalumCapacitorToPositiveArgs> {
  yTranslate = 0;

  get xTranslate(): number {
    return this.args.index * 100;
  }
}
